export default function (user) {
  if (window.X.services.user_support.enable) {
    const udeskAuth = window.X.services.user_support.udeskAuth

    // eslint-disable-next-line no-eval
    eval(window.X.services.user_support.script)

    window.ud({
      'code': '1kj06g59',
      'link': '//lingxi.udesk.cn/im_client?web_plugin_id=36406',
      'targetSelector': '.lxm-panel__icon--chat',
      'noBubble': true,
      'manualInit': true,
      'onUnread': function () {
        window.ud.showPanel()
      },
      'customer': {
        'nonce': udeskAuth.nonce,
        'signature': udeskAuth.signature,
        'timestamp': udeskAuth.timestamp,
        'web_token': udeskAuth.webToken,
        'c_name': `${user.team.name} - ${user.realname} - ${user.team.subdomain}`,
        'c_email': user.email,
        'c_phone': user.mobile,
        'c_cf_是否是微信访问': window.X.env.is_wechat ? '✅' : '❌',
        'c_org': user.team.subdomain,
        'c_created_at': user.createTime,
        'c_updated_at': user.updateTime,
        'c_cf_机构域名': user.team.subdomain,
        'c_cf_机构名称': user.team.name,
        'c_cf_灵析版本': user.team.lingxiPlan,
        'c_cf_过期时间': user.team.expireTime,
        'c_cf_注册时间': user.team.createTime,
        'c_cf_注册日期': user.team.createTime ? user.team.createTime.substr(0, 10) : '',
        'c_cf_登录时间': user.loginTime,
        'c_cf_部门': user.group.name,
        'c_cf_权限-机构管理员': user.manager ? '✅' : '❌',
        'c_cf_权限-部门管理权限': user.manager ? '✅' : '❌',
        // 手机端可以不需要这些
        // 'c_cf_权限-财务管理员': user.is_finance_admin ? '✅' : '❌',
        // 'c_cf_权限-使用群发邮箱': user.is_thirdparty_sender ? '✅' : '❌',
        // 'c_cf_权限-导出联系人': user.allow_export ? '✅' : '❌',
        // 'c_cf_权限-平台发布权限': user.allow_send_to_partner ? '✅' : '❌',
        'c_cf_访问来源': '灵析手机端',
        'c_cn_title': '在线对话用户支持记录',
        'c_cn_user-id': user.id,
        'c_cn_team-id': user.team.id,
        'c_cn_source': 'lingxi_mobile'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/user_support.js